export default __webpack_public_path__ + "static/media/users.cbe51b65.svg";